import React from "react";
import BlockTextComponent from "./BlockTextComponent";
import FlashCardImageComponent from "./FlashCardImageComponent";
import Container from "../Common/Container";
import GrammarSingleComponent from "./GrammarSingleComponent";
import ColumnContainer from "../Common/ColumnContainer";

interface GrammarGroupComponentProps {
  data: {
    id: number;
    flashCardContentComponentId: number;
    lightTheme: string;
    createdAt: string;
    updatedAt: string;
    data: {
      components: Array<{
        id: number;
        flashCardContentComponentId?: number;
        description?: string;
        lightTheme: string;
        order: number;
        grammarGroupId: number;
        britzelId?: number;
        type: string;
        flashimage?: string;
        image?: string;
        particles?: {
          inputValue: string;
          dropdownValue: {
            id: number;
            pId: number;
            name: string;
            children: Array<any>;
            particleType: string;
            particleType1: string;
            particleValue: string;
            particleValue1: string;
          };
        };
      }>;
    };
  };
  isOuterBgWhite?: boolean;
  onClick?: () => void;
}

/**
 * Each child component renders with its OWN lightTheme — independent bg and text color.
 * The outer group container is just a transparent wrapper that stacks the children.
 *
 * Flutter logic per child:
 *   lightTheme == "Light" → bg #FFFFFF, text #16162F
 *   lightTheme == "Dark"  → bg #110929, text #FFFFFF
 */
const GrammarGroupComponent: React.FC<GrammarGroupComponentProps> = ({
  data,
  isOuterBgWhite = false,
  onClick,
}) => {
  const components = data.data.components || [];
  const sortedComponents = [...components].sort((a, b) => a.order - b.order);

  return (
    <Container
      bgColor="transparent"
      color="inherit"
      borderRadius="24px"
      padding="0px"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      onClick={onClick}
    >
      <ColumnContainer flex="unset" alignItem="center" gap="0px" width="100%">
        {sortedComponents.map((component: any) => {
          // Each child uses ITS OWN lightTheme — independent of siblings and the group
          const childIsLight = component.lightTheme === "Light";
          const childBgColor = childIsLight ? "#FFFFFF" : "#110929";
          const childTextColor = childIsLight ? "#16162F" : "#FFFFFF";

          switch (component.type) {
            case "block_text":
              return (
                <BlockTextComponent
                  key={component.id}
                  id={component.id}
                  description={component.description || ""}
                  lightTheme={component.lightTheme}
                  textColor={childTextColor}
                  bgColor={childBgColor}
                  flashCardContentComponentId={component.flashCardContentComponentId}
                />
              );
            case "grammar_single":
              return (
                <GrammarSingleComponent
                  key={component.id}
                  data={component}
                  lightTheme={component.lightTheme}
                  isInsideGroup
                  groupTextColor={childTextColor}
                  isBretzel={false}
                />
              );
            case "flash_image":
              return (
                <FlashCardImageComponent
                  key={component.id}
                  id={component.id}
                  flashCardContentComponentId={
                    component.flashCardContentComponentId ||
                    component.packageFlashCardContentComponentId
                  }
                  flashimage={component.flashimage || component.image || ""}
                  order={component.order}
                  grammarGroupId={component.grammarGroupId}
                  britzelId={component.britzelId}
                  height="120px"
                  width="120px"
                />
              );
            default:
              return null;
          }
        })}
      </ColumnContainer>
    </Container>
  );
};

export default GrammarGroupComponent;
